import React from "react";
// import { Link } from "react-router-dom";
import Service from '../../service/Service';
import * as actions from '../Actions';

const service = new Service();

export default function DietPlanArticle({ eleRef, Articledata, tool }) {
    return (
        <div className="card-block">
            <div className="card_container">
                <span className="hide">{eleRef.state.relcountplus = 0, eleRef.state.relcount = 6}</span>
                {Articledata && Articledata.length > 0 && Articledata.map((articles, index1) =>
                    <div key={index1} className={'diet-plan-card act-sum' + index1} id={'month-card-' + (tool=="bd" ? parseInt(articles['weekNo'])+5 : parseInt(articles['stageId']) + 5)} rel={tool=="bd" ? eleRef.state.relcount:index1}>
                        <span className="B20_42 card_title" onClick={(e) => eleRef.viewArticle(tool=="bd" ? articles['weekNo'] :articles['stageId'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                            {articles['articleTitle']}
                        </span>
                        <div className="card-img" onClick={(e) => eleRef.viewArticle(tool=="bd" ? articles['weekNo']:articles['stageId'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                            {/* {`${articles['articleImage']}`.replace(/\.jpg$/i, ".webp")} */}
                            <img src={articles['articleImage'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/')} alt={articles['articleTitle']} title={articles['articleTitle']} className="dev_articleImage"/>
                        </div>
                        <div className="card-text R14_61 more" onClick={(e) => eleRef.viewArticle(tool=="bd" ? articles['weekNo']:articles['stageId'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                            <span className="dev_articletext">{articles["articleText"]}</span>
                        </div>
                        <div className="read_more_link" onClick={(e) => eleRef.viewArticle(tool=="bd" ? articles['weekNo']:articles['stageId'], articles['articleId'], articles['articleUrl'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'), articles['viewCount'], articles['likeCount'], articles['articleTitle'], e)}>
                            <a className="readmorelink R14_link">Read More</a>
                        </div>
                        <div className="divider-line"></div>
                        <div className="card-actions">
                            <div className="card-views social-actions">
                                <span data-icon-font="$" className="icon M14_42 view-icon">
                                </span>
                                <span className="like-count view_count M14_42">{articles['viewCount']} Views</span>
                            </div>
                            <div className="card-likes social-actions">
                                {articles && articles['isLiked'] > 0 ?
                                    (<span>
                                        <span data-icon-font="&#xe009;" className="icon M14_42 active like-icon"></span>
                                        <span className="like-count M14_42">
                                            <span className="total_likes">
                                                {articles['likeCount']}
                                            </span> Likes</span>
                                    </span>
                                    ) :
                                    (
                                        <span>
                                            <span data-icon-font="&#xe009;" className="icon M14_42 like-icon" onClick={(e) => eleRef.likeArticle(articles['articleId'], articles['stageId'], e, articles['likeCount'], articles['viewCount'], articles['articleTitle'])}>
                                            </span>
                                            <span className="like-count M14_42">
                                                <span className="total_likes">
                                                    {articles['likeCount']}
                                                </span> Likes</span>
                                        </span>
                                    )}

                            </div>
                            {tool=="bd" ?
                            <div className="social-actions">
                                {articles['isBookmarked'] ?
                                    <span className="icon bookmarkicon active" onClick={() => { eleRef.setBookMark(articles['articleId'], 0) }}>
                                        <img src={require("../images/bookmark.png")} />
                                    </span>
                                    :
                                    <span className="icon bookmarkicon" onClick={() => { eleRef.setBookMark(articles['articleId'], 1) }}>
                                        <img src={require("../images/unbookmark.png")} />
                                    </span>
                                }
                                <span className="bookmark-count M14_42">{service.intToString(articles['bookmarkCount'])} Bookmarks</span>
                            </div>:null
                            }
                            <div className="card-share right social-actions">
                                <span data-icon-font=")" className="icon M14_42 share-icon" onClick={(e) => eleRef.shareOn(e)}></span>
                                <div className="sharing-options">
                                    <ul className="left">
                                        <li className="whatsapp-share left" onClick={(e) => actions.shareArticle('whatsapp',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="whatsapp">
                                                <img src="https://parenting.firstcry.com/discussions/images/whatsapp.png" className="fetusfacebookimg" alt="" />
                                            </span>
                                        </li>
                                        <li className="facebook-share left" onClick={(e) => actions.shareArticle('facebook',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="facebook">
                                                <img src={require('../images/facebook.png')} className="facebookimg" alt="" />
                                            </span>
                                        </li>
                                        <li className="twitter-share left" onClick={(e) => actions.shareArticle('twitter',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="twitter">
                                                <img src={require('../images/twitter.png')} className="twitterimg" alt="" />
                                            </span>
                                        </li>
                                        <li className="twitter-share left" onClick={(e) => actions.shareArticle('pintrest',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="pintrest">
                                                <img src={require('../images/pintrest.png')} className="pintrestimg" alt="" />
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className="hide">
                            {eleRef.state.relcountplus++,
                                eleRef.state.relcountplus % 4 == 0 ? (
                                    eleRef.state.relcount++

                                ) : null
                            }
                        </div>
                    </div>
                )}
                <div className="share-overlay"></div>
            </div>

        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/tools/common/DietPlanArticle.js